export const Auth = {
  login: "Logged In successfully!",
  resendOTP: "We’ve sent an OTP to register email and phone number",
};
export const masterToast = {
  addVendor: "Vendor details added successfully!",
  editVendor: "Vendor details updated successfully!",
  deleteVendor: "Vendor details deleted successfully!",
  addAge: "Age Group details added successfully!",
  editAge: "Age Group details updated successfully!",
  deleteAge: "Age Group details deleted successfully!",
  addClass: "Class & Subject details added successfully!",
  editClass: "Class & Subject details updated successfully!",
  deleteClass: "Class & Subject details deleted successfully!",
  ageValidation: "From Age must be less than To Age",
  negativeAgeValidation: "Age cannot be in -ve Numbers",
};
export const ActivityToast = {
  delete: "Activities details are deleted successfully!",
  add: "Activities has been assigned successfully!",
  edit: "Activities details are updated successfully!",
  deactivate: "Activity Deactivated Successfully!",
  activate: "Activity Activated Successfully!",
};
export const SchoolToast = {
  delete: "School has been deleted successfully",
  addSchool: "School has been created successfully",
  updateSchool: "School details has been updated successfully",
  minVal: "Should be minimum 9 number",
  maxVal: "Should be maximum 15 number",
};
export const cmsToast = {
  updateTerms: "Terms & conditions details has been updated successfully",
  updatePrivacyPolicy: "Privacy policy details has been updated successfully",
  updateAboutUs: "About us details has been updated successfully",
};
export const VendorToast = {
  activate: "Service activated successfully!",
  deactivate: "Service deactivated successfully!",
  isApproval: "Service Approved successfully!",
  addvender: "Vendor has been created successfully.",
  updatevender: "Vendor has been updated successfully.",
  delete: "Vendor has been deleted successfully.",
};
export const appSettingsToast = {
  appSettingsUpdated: "App Settings has been updated successfully.",
};
export const AcademicToast = {
  delete: "Academic Year details are deleted successfully!",
  add: "Academic Year has been added successfully!",
  edit: "Activities details are updated successfully!",
  deactivate: "Academic Year Deactivated Successfully!",
  activate: "Academic Year Activated Successfully!",
};